"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M6.0832 8.2125C4.561 8.9736 4 9.8402 4 10.5c0 1.3363 1.6528 2.1439 2.7303 2.5781l-1.5126 1.5127C3.63 13.8002 2 12.4283 2 10.5c0-1.8255 1.4538-3.209 3.1888-4.0764C6.9836 5.5262 9.3931 5 12 5c2.6069 0 5.0164.5262 6.8112 1.4236C20.5462 7.291 22 8.6746 22 10.5c0 1.8255-1.4538 3.2089-3.1888 4.0764C17.0164 15.4738 14.6069 16 12 16v2.48l-3.5-3.5 3.5-3.5V14c2.3637 0 4.4542-.4812 5.9167-1.2124C19.4391 12.0264 20 11.1598 20 10.5c0-.6598-.5609-1.5264-2.0833-2.2875C16.4542 7.4812 14.3637 7 12 7c-2.3637 0-4.4542.4812-5.9168 1.2125z"
  })];
};

exports.default = _default;